// src/utils/errorHandling.js
export const handleError = (error, context = '') => {
    const userMessage = {
      default: 'An error occurred. Please try again later. Patience is a virtue.',
      auth: 'Login failed. Please check your credentials. It\'s easy to make a mistake.',
      network: 'Connection error. Please check your internet connection. Remember, the internet is way better than it was 20 years ago.',
      validation: 'Please check your input and try again. It\'s easy to make a mistake.',
      notFound: 'You are cold.The requested resource was not found.',
      forbidden: 'You do not have permission to perform this action. Sorry.'
    };
  
    // Log detailed error in development only
    if (process.env.NODE_ENV === 'development') {
      console.error(`Error in ${context}:`, error.name);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        response: error.response
      });
    }
  
    // Return appropriate user message based on error type
    if (error.response) {
      switch (error.response.status) {
        case 401:
          return userMessage.auth;
        case 403:
          return userMessage.forbidden;
        case 404:
          return userMessage.notFound;
        case 422:
          return userMessage.validation;
        default:
          return userMessage.default;
      }
    }
  
    if (error.message === 'Network Error') {
      return userMessage.network;
    }
  
    return userMessage.default;
  };